/* eslint-disable @typescript-eslint/camelcase */
import type { UpdateWeddingRequest, WWeddingView } from '@zola/svc-web-api-ts-client';
import moment from 'moment';
import { dataFormat, inputFormat } from 'components/common/form/FinalFormV2Elements';
import { WeddingDetailsFormType } from './types';
import { parseCityState } from '../../../../../helpers/weddingLocation';

export function mapWeddingStateToForm(weddingState: WWeddingView): WeddingDetailsFormType {
  const {
    owner_first_name,
    owner_last_name,
    owner_wedding_role,
    partner_first_name,
    partner_last_name,
    partner_wedding_role,
    wedding_date: weddingDate,
    hashtag,
    city,
    state_province,
    guest_count,
  } = weddingState;
  const initialFormValues = {
    owner_first_name,
    owner_last_name,
    owner_wedding_role,
    partner_first_name,
    partner_last_name,
    partner_wedding_role,
    hashtag,
    guest_count,
    location: city && state_province ? `${city}, ${state_province}` : '',
    wedding_date: weddingDate ? moment(weddingDate, dataFormat).format(inputFormat) : '',
    skipDate: weddingDate === null,
  };
  return initialFormValues;
}

// for undefined form field values not returned from react-final-form, fill in null value
export function fillFormValues(
  currentFormValues: WeddingDetailsFormType,
  initialFormValues: WeddingDetailsFormType
): WeddingDetailsFormType {
  const allFormKeys = Object.keys(initialFormValues);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return allFormKeys.reduce((acc: Record<string, any>, key) => {
    const currentValue = currentFormValues[key as keyof WeddingDetailsFormType];
    const newValue = currentValue || null;
    // fill in with empty string or
    acc[key as keyof WeddingDetailsFormType] = newValue;
    return acc;
  }, {});
}

export function mapFormToRequest(
  formData: WeddingDetailsFormType,
  weddingState: WWeddingView
): UpdateWeddingRequest {
  const {
    owner_first_name,
    owner_last_name,
    owner_wedding_role,
    partner_first_name,
    partner_last_name,
    partner_wedding_role,
    hashtag,
    guest_count,
    location,
    wedding_date: weddingDate,
    skipDate,
  } = formData;
  const parsedCityState = parseCityState(location) || { city: null, state_province: null };
  const parsedDate = {
    wedding_date: skipDate ? null : moment.utc(weddingDate, inputFormat).format(dataFormat),
  };
  const updatedApplicableFields = Object.assign(
    {
      owner_first_name,
      owner_last_name,
      owner_wedding_role,
      partner_first_name,
      partner_last_name,
      partner_wedding_role,
      hashtag,
      guest_count,
    },
    parsedCityState,
    parsedDate
  );
  // request expects full weddingState with other values not applicable to form
  return Object.assign({}, weddingState, updatedApplicableFields);
}



// WEBPACK FOOTER //
// ./src/pages/settings/wedding/WeddingDetails/util/mappers.ts